import { Lightning, Log } from '@lightningjs/sdk'
import { KeyboardButton, KeyboardTemplate } from './'

export default class Keyboard extends Lightning.Component {
  static _template() {
    return {}
  }

  get keyboardTemplate() {
    return KeyboardTemplate
  }

  get keyboardButton() {
    return KeyboardButton
  }

  get maxCharacters() {
    return 36
  }

  set value(v) {
    if (v.length < this.maxCharacters) {
      this._value = v

      // this.fireAncestors("$keyboardValueChanged", {value: v});
    }
  }

  get value() {
    return this._value
  }

  get rows() {
    return this.children
  }

  get rowLength() {
    return this.rows[this.rowIndex].children.length
  }

  get currentKey() {
    return this.children[this.rowIndex].children[this.colIndex]
  }

  set layout(layout) {
    this._layout = layout

    this._update()
  }

  get layout() {
    return this._layout
  }

  set keyMeasure(ms) {
    this._keyMeasure = ms
  }

  _getFocused() {
    return this.currentKey
  }

  _navigate(dir, value) {
    dir = dir === 'up' || dir === 'down' ? 'vertical' : 'horizontal'

    if (
      dir === 'horizontal' &&
      this.colIndex + value < this.rowLength &&
      this.colIndex + value > -1
    ) {
      this.previous = null

      return (this.colIndex += value)
    } else if (
      dir === 'vertical' &&
      this.rowIndex + value < this.rows.length &&
      this.rowIndex + value > -1
    ) {
      const currentColIndex = this.colIndex,
        targetRow = this.rowIndex + value

      if (this.previous && this.previous.row === targetRow) {
        const tmp = this.previous.col

        this.previous.col = this.colIndex
        this.colIndex = tmp
      } else {
        const targetRow = this.children[this.rowIndex + value],
          targetItems = targetRow.children,
          ck = this.currentKey

        let target = 0

        for (let i = 0; i < targetItems.length; i++) {
          const ckx = this.children[this.rowIndex].x + ck.x,
            tix = targetRow.x + targetItems[i].x

          if ((ckx >= tix && ckx <= tix + targetItems[i].w) || (tix >= ckx && tix <= ckx + ck.w)) {
            target = i
            break
          }
        }

        this.colIndex = target
      }

      this.previous = { col: currentColIndex, row: this.rowIndex }

      return (this.rowIndex += value)
    }

    return false
  }

  _update() {
    if (this._layout && this.keyboardTemplate.layouts[this._layout] === undefined) {
      Log.error(
        `Configured layout "${this.layout}" does not exist. Reverting to "${
          Object.keys(this.keyboardTemplate.layouts)[0]
        }"`
      )
      this._layout = null
    }

    if (!this._layout) {
      this._layout = Object.keys(this.keyboardTemplate.layouts)[0]
    }

    const {
      keyWidth,
      keyHeight,
      horizontalSpacing = 0,
      verticalSpacing = 0,
      fontFace,
      fontSize,
      rows,
    } = this.keyboardTemplate.layouts[this._layout]

    this.children = rows.map((row, rowIndex) => {
      let keyOffset = 0

      const {
        x = 0,
        rowVertOffset,
        rowVerticalSpacing = verticalSpacing,
        rowHorizontalSpacing = horizontalSpacing,
        keys = [],
      } = row

      let rowY = keyHeight * rowIndex + rowIndex * rowVerticalSpacing

      if (rowVertOffset && rowVertOffset > 0) {
        rowY = rowVertOffset
      }

      return {
        y: rowY,
        x,
        children: keys.map(key => {
          key = Object.assign({ action: 'input' }, key)

          const prevOffset = keyOffset,
            { w = keyWidth, h = keyHeight, action, toLayout, keyHorOffset, keyBG } = key

          keyOffset += w + rowHorizontalSpacing + (keyHorOffset ? keyHorOffset : 0)

          return {
            key,
            action,
            toLayout,
            x: prevOffset + (keyHorOffset ? keyHorOffset : 0),
            w,
            h,
            fontFace,
            fontSize,
            type: this.keyboardButton,
            layout: this._layout,
            keyBG,
          }
        }),
      }
    })

    this.colIndex = 0
    this.rowIndex = 0
  }

  reset() {
    this.colIndex = 0
    this.rowIndex = 0
    this._value = ''
    this.previous = null
  }

  _init() {
    this._keyMeasure = null

    this.reset()

    this._update()
  }

  _handleRight() {
    return this._navigate('right', 1)
  }

  _handleLeft() {
    return this._navigate('left', -1)
  }

  _handleUp() {
    if (this.rowIndex === 0) {
      return false
    } else {
      return this._navigate('up', -1)
    }
  }

  _handleDown() {
    return this._navigate('down', 1)
  }

  _handleEnter() {
    const key = this.currentKey

    switch (key.action) {
      case 'input':
        this.value += key.c
        break
      case '.com':
      case '@gmail.com':
      case '@hotmail.com':
      case '@yahoo.com':
        this.value += key.c
        break
      case 'backspace':
        if (this.value.length > 0) {
          this.value = this.value.slice(0, -1)
        }
        break
      case 'space':
        if (this.value.length > 0) {
          this.value += ' '
        }
        break
      case 'clear':
        this.value = ''
        break
      case 'toggleToLayout':
        this.layout = key.toLayout
        break
      default:
        this.signal(key.action)
    }

    this.signal('valueChanged', this.value)
  }

  _handleKey(keydata) {
    let tempRow = -1,
      tempCol = -1,
      template = this.keyboardTemplate.layouts[this._layout]

    template.rows.forEach((row, rowIndex) => {
      row.keys.forEach((col, colIndex) => {
        let key = template.rows[rowIndex].keys[colIndex]

        if (key.c && key.c.toLowerCase() === keydata.key.toLowerCase()) {
          tempRow = rowIndex
          tempCol = colIndex

          return false
        }
      })
    })

    if (tempRow === -1 || tempCol === -1) {
      return false
    }

    this.colIndex = tempCol
    this.rowIndex = tempRow

    this._handleEnter()
  }
}
